<template>
  <div>
    <div class="good-list" style="height: calc(100vh - 100px - 245px )">
        <div v-if="details.length<=0" style="padding-top:15vh;text-align: center;color:#999">
            <i class="icon iconzanwushuju2" style="font-size:60px"></i>
        </div>
        <div class="ct-order" v-for="(item,index) in details">
          <div class="order-item">
              <div class="item-icon">
                  <i class="icon iconkucun1"></i>
              </div>
          </div>
          <div class="order-box">
              <div class="box-group">
                  <div class="box-tl numColor" style="font-size:15px;font-weight:600">{{item.name}}</div>
              </div>
              <div class="box-group">
                  <div class="box-text" style="flex:2">{{item.code?item.code:'-'}}</div>
                  <div class="box-text">{{item.unit?item.unit:'-'}}</div>
                  <div class="box-text">{{item.goodSpec?item.goodSpec:'-'}}</div>
              </div>
              <div class="box-group" style="align-items:center;">
                  <div class="box-text">
                      <div>数量：<span class="numColor">{{item.count | money}}</span></div>
                      <div style="color:#4C37B6">销售金额：<span class="numColor" style="font-weight:600">{{item.amount | money}}</span></div>
                  </div>
                  <div style="width:1px;background-color:#666;height:40px;margin-right:20px" v-if="$store.state.supplierInfo.type=='JOINT_VENTURE'"></div>
                  <div class="box-text" v-if="$store.state.supplierInfo.type=='JOINT_VENTURE'">
                      <div>扣点率：<span class="numColor">{{item.deductPercent | money}}%</span></div>
                      <div style="color:#4C37B6">扣点金额：<span class="numColor"  style="font-weight:600">{{item.deductAmount | money}}</span></div>
                  </div>
              </div>
          </div>
      </div>
    </div>
    <div v-if="$store.state.supplierInfo.type=='JOINT_VENTURE'" style="height:40px;background:#FFF;text-align:right;color:#486ad8;line-height:40px;padding:0px 20px;display:flex">
      <div style="flex:1;text-align:left">销售金额：<span style="font-size:15px;font-weight:600;">{{sumAmount | money}}</span></div>
      <div style="flex:1;">扣点金额：<span style="font-size:15px;font-weight:600;">{{sumDeductAmount | money}}</span></div>
    </div>
    <div v-if="active=='payment'" style="height:40px;background:#FFF;text-align:right;color:#486ad8;line-height:40px;padding-right:20px">销售金额：<span style="font-size:15px;font-weight:600">{{sumAmount | money}}</span></div>
  </div>
</template>

<script>
export default {
  props:['details'],
    data() {
        return {
            hasBatch: false,
            showGoods: false,
            canceDel: 0,
            list: [{}],
            showEdit: false,
            selectGoods: {},
            settings: {},
            selectIndex: 0,
            sumAmount:0,
            sumDeductAmount:0,
        }
    },
    watch:{
      details:function(newVal,oldVal){
        this.sumAmount=newVal.reduce(function(prev, cur) {
            return cur.amount + prev;
        }, 0);
        if(this.$store.state.supplierInfo.type=='JOINT_VENTURE'){
          this.sumDeductAmount=newVal.reduce(function(prev, cur) {
            return cur.deductAmount + prev;
          }, 0);
        }
      },
    },
    methods:{
      goDetail(item){
        if(item.type == 'STOREIN' || item.type == 'RIPEIIN' || item.type == 'SUPPLIER_DELIVER' || item.type == 'SUPPLIER_DELIVER'){
          this.router.push({path:"/stockInReportDetail",query:{orderId:item.storeOrderId}})
        }else if(item.type != 'SUPPLIER_EXPENSE'){
          this.router.push({path:"/stockOutReportDetail",query:{orderId:item.storeOrderId}})
        }
      },
    }
}
</script>

<style>
.order-search{
  display: flex;
  padding: 5px 10px;
  height:50px;
  box-sizing: border-box;
  background-color: #FFF;
  align-items: center;
}
.order-search .search-input{
  width: calc(100% - 150px)
}
.order-search .search-input input{
  width: 100%;
  padding-left:5px;
  font-size: 14px;
  color:#888;
}
.order-search .search-icon{
  width: 150px;
  display: flex;
  height: 40px;
  box-sizing: border-box;
}
.order-search .search-icon .icon{
  font-size: 20px;
  color:#FFF;
}
.order-search .search-icon .icon-search{
  width: 75px;
  box-sizing: border-box;
  background-color: #486ad8;
  line-height: 40px;
  text-align: center;
}
.order-search .search-icon .icon-scan{
  width: 75px;
  color:#FFF;
  border-left: 1px solid #ccc;
  background-color: #486ad8;
  text-align: center;
  line-height: 40px;
  box-sizing: border-box;
}

.btns{
  display: flex;
  height: 50px;
  padding: 5px;
  line-height: 40px;
  box-sizing: border-box;
  background-color: #FFF;
}
.save{
  width: calc(50% - 10px);
  margin:0px 5px;
  text-align: center;
  
  font-size: 15px;
  background-color: #787CD2;
  color: #FFF;
}
.code{
  width: calc(50% - 10px);
  margin:0px 5px;
  font-size: 15px;
  text-align: center;
  background-color: #00B26A;
  color: #FFF;
}

.good-list-title{
  display:flex;
  border-bottom:1px solid #eee;
  font-size:15px;
  color:#333;
  height: 40px;
  line-height: 40px;
}
.good-list{
  overflow-y: auto;
  font-size: 14px;
}
.good-list .good-item{
  display: flex;
  background-color:#FFF;
  margin-bottom: 5px;
  border-bottom: 1px solid #efefef;
  height: 30px;
  line-height: 30px;
}.good-list .list-item .item-index{
  background-color: #4935ae;
  color:#FFF;
  border-radius: 50%;
  display: inline-block;
  font-size: 12px;
  width: 23px;
  height: 23px;
  line-height: 23px;
  text-align: center;
}.good-list .list-item{
  margin-bottom: 5px;
  background-color: #FFF;
  color:#333;
  padding:10rpx 0rpx;
  border-bottom: 1px solid #f5f5f5;
  box-sizing: border-box;
}
.good-list .list-item .item-index text{
  display: block;
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 50%;
  background-color: #486ad8;
  color: #FFF;
  text-align: center;
}
.good-list-price{
  text-align:left;
  font-size:14px;
  color:#4935ae;
}
.good-list .good-item .item-select{
  display: flex;
  justify-content: center;
  align-items: center;
  zoom: 0.8;
}
.good-item-detail{
  display: flex;
  align-items: center;
  background-color: #FFF;
  margin:5px;
}
.good-item-detail .item-select{
  width:40px;
  zoom: 0.8;
  text-align: center;
} 
.good-item-detail .item-box{
  width: calc(100% - 40px);
}
.good-item-detail .item-box .box-name{
  font-size:14px;
  color: #666;
  padding: 5px;
}
.good-item-detail .item-box .box-ck{
  display: flex;
  padding: 5px;
}
.good-item-detail .item-box .box-ck .box-code{
  width: 100px;
  font-size: 12px;
}
.good-item-detail .item-box .box-ck .box-keycode{
  width: calc(100% - 100px);
  font-size: 12px;
}
.good-list .good-item .text-center{
  font-size: 12px;
}
.good-list .good-item .row-cell{
  display: flex;
  height:25px;
  align-items: center;
  font-size: 12px;
}
.good-list .good-item .row-cell .item-left{
  flex:1;
      overflow: hidden;
  /*自动隐藏文字*/
  text-overflow: ellipsis;
  /*文字隐藏后添加省略号*/
  white-space: nowrap;
  /*强制不换行*/
}
.good-list .good-item .row-cell .item-right{
  flex:1;
  overflow: hidden;
  /*自动隐藏文字*/
  text-overflow: ellipsis;
  /*文字隐藏后添加省略号*/
  white-space: nowrap;
}
.good-list .good-item .row-cell .endNum{
      background-color: #2196f3;
      color: #FFF;
      padding: 5px 10px;
      border-radius: 50px;
}
.order-price{
  color:#F56C6C;
  font-weight: 600
}
.ct-order{
    background-color: #fff;
    margin-bottom: 10px;
    padding:5px 0px;
    display: flex;
}
.ct-order .order-item{
    width: 40px;
    text-align: center;
}
.ct-order .order-item .item-icon i{
    color:#4c37b6;
    font-size: 22px;
}
.ct-order .order-box{
    width: calc(100% - 50px);
    padding:6px 0px;
}
.ct-order .order-box .box-tl{
    font-size: 14px;
    flex: 2;
    margin-bottom: 5px
}
.ct-order .order-box .box-text{
    font-size: 12px;
    padding: 4px 0;
    flex: 1;
    box-sizing: border-box;
    color: #888;
}
.ct-order .order-box .box-btn{
    margin-top: 5px;
    width: 90%;
    color: #FFF;
    background-color:#486ADB;
    border-radius: 5px;
    padding: 7px 0px;
    margin-bottom:10px;
    font-size: 14px;
    text-align: center;
}
.ct-order .order-box .box-group{
    display: flex;
}
.ct-order .order-box .box-btn text{
    color: #FFF;
    
}
.ct-order .order-box .box-btn .icon{
    font-size: 15px
}
.sum{
    color:#4c37b6
}
.sum .sum-txt{
    font-size: 12px;
}
.sum .sum-val{
    font-size: 16px;
}
.numColor{
}
</style>


// WEBPACK FOOTER //
// src/views/stateMent/wxSaleDetailsTable.vue